export const STORIES_CREATE_PROMO_LOCAL_STORAGE_KEY = 'storycreatepromo';
